import { type ContactInformationView } from "shared/mappers/database/profile/contact-information";
import {
  type ProfileDto,
  type ProfileView,
} from "shared/mappers/database/profile/profile";

export const defaultContactInformationFromProfile = ({
  profile,
  use,
  type,
  notBlankProperty,
}: {
  profile: ProfileDto | ProfileView | undefined;
  use?: "Billing" | "Shipping" | string;
  type?: "Postal" | "Physical" | string;
  notBlankProperty?: "email" | "phone";
}): ContactInformationView | undefined => {
  return (
    profile?.contactInformation?.find((ci) => {
      if (
        use &&
        type &&
        ci.use?.some((ciUse) => ciUse.description === use) &&
        ci.type?.description === type
      ) {
        if (
          notBlankProperty &&
          (!ci[notBlankProperty] || ci[notBlankProperty] === "")
        ) {
          return false;
        }
        return true;
      }
      if (use && ci.use?.some((ciUse) => ciUse.description === use)) {
        if (
          notBlankProperty &&
          (!ci[notBlankProperty] || ci[notBlankProperty] === "")
        ) {
          return false;
        }
        return true;
      }
      if (type && ci.type?.description === type) {
        if (
          notBlankProperty &&
          (!ci[notBlankProperty] || ci[notBlankProperty] === "")
        ) {
          return false;
        }
        return true;
      }
      return false;
    }) ??
    (notBlankProperty
      ? profile?.contactInformation?.find(
          (ci) => ci[notBlankProperty] && ci[notBlankProperty] !== "",
        )
      : undefined) ??
    profile?.contactInformation?.[0] ??
    undefined
  );
};
